import SecCodesRequests from '../../requests/codes/sec-codes-requests.js';

export default class SecCodesService {
    static async getSecCodes() {
        return SecCodesRequests.getAllSecCodes();
    }
}
